import { z } from 'zod';

export const PILLAR_KEYS = ['style', 'food', 'health', 'family', 'culture'] as const;
export const pillarKeySchema = z.enum(PILLAR_KEYS);
export type PillarKey = z.infer<typeof pillarKeySchema>;

/**
 * Curated launch-day segment list. Backed by the strategy spec; the API does
 * not (yet) expose an enum endpoint, so the admin UI ships this canonical set
 * and accepts free text via fallthrough on existing data.
 */
export const LAUNCH_SEGMENT_KEYS = [
  'mother_wife',
  'professional',
  'student',
  'creator',
  'modest',
  'bridal',
  'plus_men',
  'kids_caregiver',
  'fitness_active',
] as const;
export const launchSegmentSchema = z.string().min(1).max(60);

export const isoYearMonthDay = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/u, { message: 'Expected YYYY-MM-DD.' });

export const hexAccentColor = z.string().max(16);

export const uuid = z.string().uuid();

export type LaunchSegmentKey = (typeof LAUNCH_SEGMENT_KEYS)[number];
